// Simple changes the markdown to fit our graphical profile better
const HTMLRenderer = ({ style = {}, children }) => (
  <div
    style={{ fontFamily: "Dagny, Roboto, Helvetica, Arial, sans-serif", ...style }}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

export default HTMLRenderer;
